export default {
	title: 'Maintenance en cours',
	message: 'L\'application n\'est pas disponible pour le moment, veuillez nous excuser pour la gêne occasionnée.'
};
